<template>
  <label
    :for="sid"
    class="toggle"
    v-bind:class="{'state-disabled':disabled, 'state-error': model.$error, 'to-left':toLeft}"
  >
    <input
      type="checkbox"
      :checked="checked"
      :disabled="disabled"
      :id="sid"
      ref="input"
      value="true"
      @change="onInput($event)"
      @focus="onFocus($event)"
      @blur="onBlur($event)"
      :name="model.$form.testPath ? model.$path : undefined"
    />
    <i :data-swchon-text="on" :data-swchoff-text="off" :style="toggleWidth"></i>
    <label :for="sid" class="label">
      <slot>{{getTitle}}</slot>
    </label>
    <w-error :model="model" v-if="showError"></w-error>
  </label>
</template>

<script>
import modelMixin from '../mixins/modelMixin';

import WError from './error.vue';
import WTooltip from './tooltip.vue';

export default {
  name: 'w-checkbox',
  props: {
    uncheckvalue: {
      type: String
    },
    showError: {
      type: Boolean,
      default: true
    },
    on: {
      type: String,
      default: 'Tak'
    },
    off: {
      type: String,
      default: 'Nie'
    },
    toLeft: {
      type: Boolean,
      default: false
    }
  },
  mixins: [modelMixin],
  components: {WError, WTooltip},
  data() {
    return {
      sid: 'chk' + Math.random() * 1000000
    };
  },
  computed: {
    toggleRight() {
      return 36 + this.extendedWidth + 'px';
    },
    toggleWidth() {
      return {
        width: 49 + this.extendedWidth + 'px'
      };
    },
    extendedWidth() {
      let length = this.on.length > this.off.length ? this.on.length : this.off.length;
      length -= 3;
      if (length <= 0) {
        length = 0;
      }
      return length * 4.4;
    },
    unvalue() {
      if (this.uncheckvalue === undefined) {
        if (this.value === 'true') {
          return 'false';
        } else if (this.value === 'on') {
          return 'off';
        } else {
          return false;
        }
      } else {
        return this.uncheckvalue;
      }
    },
    checked() {
      // let vv = this.$model.$value;
      if (this.$options.hasFocus) {
        return this.$options.localValue;
      }
      switch (this.model.$schema.type) {
        case 'boolean':
          return this.model.$value === 'true';
        case 'array':
          return this.model.$value.indexOf(this.value) > -1;
        default:
          return this.model.$value === this.value;
      }
    }
  },
  mounted() {
    this.applyCSS();
  },

  beforeUpdate() {
    this.applyCSS();
  },
  methods: {
    applyCSS() {
      const cssRule = `.smart-form .toggle input:checked + i:before {right: ${this.toggleRight}}`;
      const style = document.createElement('style');
      style.type = 'text/css';
      // append the style node as child of current component
      this.$el.appendChild(style);
      style.innerHTML = cssRule;
    },
    onFocus(evt) {
      this.$options.hasFocus = true;
      this.$emit('focus');
      this.model.$hasFocus = true;
    },
    onBlur(evt) {
      this.$options.hasFocus = false;
      this.$emit('blur');
      this.model.$hasFocus = false;
    },
    onInput(evt) {
      this.$options.localValue = evt.target.checked;
      if (evt.target.checked) {
        switch (this.model.$schema.type) {
          case 'boolean':
            this.model.$value = 'true';
            break;
          case 'string':
            this.model.$value = this.value;
            break;
          case 'array':
            const pos = this.model.$value.indexOf(this.$props.value);
            if (pos === -1) {
              this.model.$addRow(this.$props.value);
            }
            break;
        }
      } else {
        switch (this.model.$schema.type) {
          case 'boolean':
            this.model.$value = 'false';
            break;
          case 'string':
            this.model.$value = this.unvalue;
            break;
          case 'array':
            const pos = this.model.$value.indexOf(this.$props.value);
            if (pos > -1) {
              this.model.$removeRow(pos);
            }
            break;
        }
      }
      this.$emit('input');
      this.fieldChanged();
    }
  }
};
</script>


<style scoped>
label.to-left.toggle > i {
  top: auto;
  right: auto;
  left: 0;
  bottom: auto;
}
label.to-left.toggle {
  padding-left: 61px;
  padding-right: auto;
}
.toggle {
  display: inline-block !important;
  padding-right: 0px !important;
}
.smart-form .toggle i {
  display: inline-block;
  position: inherit;
}
.smart-form .toggle i + label {
  display: inline-block;
}
</style>